module.exports = __webpack_public_path__ + "static/media/sc_6_i.500e5cbd.png";